export default "__VITE_ASSET__DUiqh$VE__"